module.exports = __webpack_public_path__ + "static/massart-demo-4ebada773f1b53668c55c996ec3275a1.mp4";